/* eslint-disable */
export default {
  completeQuote: (payload) => new Promise(((resolve) => {
    let countryCode = payload.customer.address.country_code || 'CA';
    const dummyQuote = countryCode === 'CA'
      ? require('../../mock/insuranceQuote.json')
      : require('../../mock/insuranceQuoteUS.json');
    setTimeout(() => {
      resolve({ data: dummyQuote });
    }, 5000);
  })),
  sendVerificationCode: payload => new Promise(((resolve) => {
    setTimeout(() => {
      resolve({ data: require('../../mock/insuranceSendVerification.json') });
    }, 1000);
  })),
  verifyCode: payload => new Promise(((resolve) => {
    setTimeout(() => {
      resolve({ data: require('../../mock/insuranceVerifyCode.json') });
    }, 1000);
  })),
  resendCode: payload => new Promise(((resolve) => {
    setTimeout(() => {
      resolve({ data: require('../../mock/insuranceResendCode.json') });
    }, 1000);
  })),
};
